import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {Interlignage, PoliceNames, style, ThemesNames} from "../models/style.model";
import {StatusEnseignant} from "../../../suaps/common/services/enseignant/enseignant.model";


@Injectable({
  providedIn: 'root'
})
export class StyleService {

  private readonly LS_KEY = "DEFAULT_THEME";

  private readonly THEME1_THEME_NAME = ThemesNames.theme1;
  private readonly THEME1_NAV_BG = '#474747'; /* #872525 */
  private readonly THEME1_NAV_FONT_COLOR = '#e8deb6';
  private readonly THEME1_BODY_BG_COLOR = '#e3e3e3';

  private readonly THEME2_THEME_NAME = ThemesNames.theme2;
  private readonly THEME2_NAV_BG = '#d0baad';
  private readonly THEME2_NAV_FONT_COLOR = '#fff8f0';
  private readonly THEME2_BODY_BG_COLOR = '#fff8f0';

  private readonly THEME3_THEME_NAME = ThemesNames.theme3;
  private readonly THEME3_NAV_BG = '#b71c1c';
  private readonly THEME3_NAV_FONT_COLOR = '#FFF';
  private readonly THEME3_BODY_BG_COLOR = '#f9e9e9';

  private readonly THEME4_THEME_NAME = ThemesNames.theme4;
  private readonly THEME4_NAV_BG = '#57564E';
  private readonly THEME4_NAV_FONT_COLOR = '#e8deb6';
  private readonly THEME4_BODY_BG_COLOR = '#e3e3e3';

  private readonly THEME5_THEME_NAME = ThemesNames.theme5;
  private readonly THEME5_NAV_BG = '#262442';
  private readonly THEME5_NAV_FONT_COLOR = '#a3b2bf';
  private readonly THEME5_BODY_BG_COLOR = '#403e60';

  private readonly INVERSE_THEME_NAME = ThemesNames.inverse;
  private readonly INVERSE_NAV_BG = '#000a69';
  private readonly INVERSE_NAV_FONT_COLOR = '#FF0';
  private readonly INVERSE_BODY_BG_COLOR = '#000a69';

  private readonly RENFORCE_THEME_NAME = ThemesNames.renforce;
  private readonly RENFORCE_NAV_BG = '#343643';
  private readonly RENFORCE_NAV_FONT_COLOR = '#f9fcff';
  private readonly RENFORCE_BODY_BG_COLOR = '#343643';

  private readonly THEMES : Map<style, string>[] = [];
  private readonly THEME_NAMES = [];

  interlignage = new BehaviorSubject(Interlignage.default);
  police = new BehaviorSubject(PoliceNames.default);
  mainStyle = new BehaviorSubject(<style>{
    themeName: this.THEME3_THEME_NAME,
    navBackground: this.THEME3_NAV_BG,
    navFontColor: this.THEME3_NAV_FONT_COLOR,
    bodyBgColor: this.THEME3_BODY_BG_COLOR,});

  mainStyle$ = this.mainStyle.asObservable();
  interlignage$ = this.interlignage.asObservable();
  police$ = this.police.asObservable();

  constructor() {
    this._initThemes();
    this._initThemesNames();
    this._getStoredTheme();
  }

  updateMainBGColor(className: string){
    this.mainStyle.next(this.THEMES[className]);
    this._setStoredTheme(className);
  }

  updateMainInterlignage(interlignage: Interlignage){
    this.interlignage.next(interlignage);
  }

  updateMainpolice(police: PoliceNames){
    this.police.next(police);
  }

  getThemeName(themeName: string): string{
    return this.THEME_NAMES[themeName];
  }

  private _setStoredTheme(themeName: string){
    localStorage.setItem(this.LS_KEY, themeName);
  }

  private _initThemes(): void {

    this.THEMES[ThemesNames.theme1] = {
      themeName: this.THEME1_THEME_NAME,
      navBackground: this.THEME1_NAV_BG,
      navFontColor: this.THEME1_NAV_FONT_COLOR,
      bodyBgColor: this.THEME1_BODY_BG_COLOR
    };
    this.THEMES[ThemesNames.theme2] = {
      themeName: this.THEME2_THEME_NAME,
      navBackground: this.THEME2_NAV_BG,
      navFontColor: this.THEME2_NAV_FONT_COLOR,
      bodyBgColor: this.THEME2_BODY_BG_COLOR
    };
    this.THEMES[ThemesNames.theme3] = {
      themeName: this.THEME3_THEME_NAME,
      navBackground: this.THEME3_NAV_BG,
      navFontColor: this.THEME3_NAV_FONT_COLOR,
      bodyBgColor: this.THEME3_BODY_BG_COLOR
    };
    this.THEMES[ThemesNames.theme4] ={
      themeName: this.THEME4_THEME_NAME,
      navBackground: this.THEME4_NAV_BG,
      navFontColor: this.THEME4_NAV_FONT_COLOR,
      bodyBgColor: this.THEME4_BODY_BG_COLOR
    };
    this.THEMES[ThemesNames.theme5] ={
      themeName: this.THEME5_THEME_NAME,
      navBackground: this.THEME5_NAV_BG,
      navFontColor: this.THEME5_NAV_FONT_COLOR,
      bodyBgColor: this.THEME5_BODY_BG_COLOR
    };
    this.THEMES[ThemesNames.inverse] = {
      themeName: this.INVERSE_THEME_NAME,
      navBackground: this.INVERSE_NAV_BG,
      navFontColor: this.INVERSE_NAV_FONT_COLOR,
      bodyBgColor: this.INVERSE_BODY_BG_COLOR
    };
    this.THEMES[ThemesNames.renforce] = {
      themeName: this.RENFORCE_THEME_NAME,
      navBackground: this.RENFORCE_NAV_BG,
      navFontColor: this.RENFORCE_NAV_FONT_COLOR,
      bodyBgColor: this.RENFORCE_BODY_BG_COLOR
    };
  }

  private _initThemesNames(): void{
    this.THEME_NAMES[this.THEME1_THEME_NAME] = 'Red & Gold';
    this.THEME_NAMES[this.THEME2_THEME_NAME] = 'Sand';
    this.THEME_NAMES[this.THEME3_THEME_NAME] = 'Paris 8';
    this.THEME_NAMES[this.THEME4_THEME_NAME] = 'Olive';
    this.THEME_NAMES[this.THEME5_THEME_NAME] = 'Night';
    this.THEME_NAMES[this.INVERSE_THEME_NAME] = 'Inverser';
    this.THEME_NAMES[this.RENFORCE_THEME_NAME] = 'Renforcer';
  }


  private _getStoredTheme(): void {
    if(localStorage.getItem(this.LS_KEY)){
      this.mainStyle.next(this.THEMES[localStorage.getItem(this.LS_KEY)]);
    }
  }

}
